import React, { useContext, useRef } from 'react';

import { useOnScreen } from '../../hooks/useOnScreen';

import type { FC } from 'react';

type PremiumVisibleContext = {
  premiumVisible: boolean;
  ref: React.MutableRefObject<HTMLDivElement | null>;
};

const premiumVisibleContext = React.createContext<PremiumVisibleContext>({
  premiumVisible: false,
  ref: { current: null },
});

export const TotalPremiumVisibilityProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const premiumVisible = useOnScreen(ref);

  return <premiumVisibleContext.Provider value={{ premiumVisible, ref }}>{children}</premiumVisibleContext.Provider>;
};

export const useTotalPremiumVisibility = () => {
  const context = useContext(premiumVisibleContext);

  if (!context) throw new Error(`You must use this hook inside a TotalPremium context`);

  return context;
};
